<template>
	<div>
		<el-card class="searchItemFlex">
			<el-date-picker v-model="queryParam.yearStr" value-format="yyyy" type="year" placeholder="年份" style="width: 120px"
				size="mini"></el-date-picker>
			<el-select v-model="queryParam.month" placeholder="月份" size="mini" clearable filterable>
				<el-option v-for="item in 12" :key="item" :label="item.toString() + '月'" :value="item.toString()"></el-option>
			</el-select>
			<el-select v-model="queryParam.field" placeholder="操作域">
				<el-option v-for="item in actionFieldList" :key="item.id" :label="item.label" :value="item.id">
			</el-option>
			</el-select>
			<el-select v-model="queryParam.type" size="mini" clearable placeholder="操作类型" @clear="queryParam.type = null">
				<el-option v-for="item in actionTypeList" :key="item.id" :label="item.name" :value="item.id">
				</el-option>
			</el-select>
			<el-input v-model="queryParam.userName" size="mini" clearable placeholder="用户名"></el-input>
			<el-checkbox v-model="queryParam.marked" border size="mini">标记日志</el-checkbox>
			<el-button type="primary" size="mini" @click="getActionList"><i class="el-icon-search"></i>&nbsp;查询</el-button>
			<el-button type="warning" size="mini" @click="reset"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
		</el-card>
		<el-table :data="actionList" ref="ActionTable" height="610" border size="mini" v-loading="actionLoading"
			@sort-change="sortChange" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(255, 255, 255, 0.8)">
			<div slot="empty">
				<el-empty description="没有任何数据呢~"></el-empty>
			</div>
			<el-table-column label="编号" width="60" prop="id" show-overflow-tooltip></el-table-column>
			<el-table-column label="操作人" width="70" prop="userName" show-overflow-tooltip></el-table-column>
			<el-table-column label="操作域" width="100" prop="field" show-overflow-tooltip>
				<template v-slot="{ row }">
					{{ actionFieldList.find(item => parseInt(item.id) === row.field).label || '-' }}
				</template>
			</el-table-column>
			<el-table-column label="类型" width="80" prop="type" show-overflow-tooltip :sortable="'custom'">
				<template slot-scope="scope">
					{{ actionTypeList[scope.row.type].name }}
				</template>
			</el-table-column>
			<el-table-column label="描述" width="140" prop="description" show-overflow-tooltip></el-table-column>
			<el-table-column label="接口名" width="160" prop="method" show-overflow-tooltip></el-table-column>
			<el-table-column label="参数" width="200" prop="params" show-overflow-tooltip></el-table-column>
			<el-table-column label="返回值" width="180" prop="returnValue" show-overflow-tooltip></el-table-column>
			<el-table-column label="操作时间" width="160" prop="createTime" :sortable="'custom'">
				<template slot-scope="scope">
					<el-tag size="mini" type="info">{{
						scope.row.createTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
					}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="标记" width="95" prop="marked">
				<template slot-scope="scope">
					<el-tag size="mini" type="success" v-if="!scope.row.marked">未标记操作</el-tag>
					<el-tag size="mini" type="warning" v-else>标记操作</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right">
				<template slot-scope="scope">
					<el-tooltip content="详情" placement="top" effect="light">
						<el-button type="primary" circle size="mini" icon="el-icon-view"
							:disabled="rightList.indexOf('action_log') < 0" @click="openView(scope.row)"></el-button>
					</el-tooltip>
					<el-tooltip content="解除标记" placement="top" effect="light" v-if="scope.row.marked">
						<el-button type="success" circle size="mini" icon="el-icon-check"
							:disabled="rightList.indexOf('action_log') < 0"
							@click="mark(scope.row.id, scope.row.yearStr, false)"></el-button>
					</el-tooltip>
					<el-tooltip content="添加标记" placement="top" effect="light" v-else>
						<el-button type="danger" circle size="mini" icon="el-icon-close"
							:disabled="rightList.indexOf('action_log') < 0"
							@click="mark(scope.row.id, scope.row.yearStr, true)"></el-button>
					</el-tooltip>
				</template>
			</el-table-column>
		</el-table>
		<!--分页部分-->
		<el-pagination background @size-change="pagesizeChange" @current-change="pagenumChange"
			:current-page="queryParam.pageNum" :page-sizes="[10, 50, 100, 200, 500]" :page-size="queryParam.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 10px">
		</el-pagination>
		<action-detail ref="ActionDetail" :actionDetailVisible="actionDetailVisible"
			@changeVisible="changeVisible"></action-detail>
	</div>
</template>
<script>
import actionTypeList from "@/data/actionTypeList";
import rightList from "@/util/rightList";
import ActionDetail from "@/components/log/ActionDetail";
import { dataList } from '@/api/dict'
export default {
	name: "ActionView",
	props: {
	},
	components: { ActionDetail },
	data() {
		return {
			rightList: rightList(),
			queryParam: {
				yearStr: new Date().getFullYear().toString(),
				month: null,
				userName: "",
				type: null,
				field: null,
				marked: false,
				order: 0,
				pageSize: 50,
				pageNum: 1,
			},
			actionTypeList,
			actionFieldList: [],
			actionList: [],
			total: 0,
			actionLoading: false,
			actionDetailVisible: false,
		};
	},
	mounted() { 
		this.getActionFieldList();
	},
	methods: {
		changeVisible(val) {
			this.actionDetailVisible = val;
		},
		async getActionList() {
			if (this.queryParam.yearStr == null) {
				return this.$message.warning("请指定日志年份！");
			}
			this.actionLoading = true;
			const { data: res } = await this.$http
				.post("al/page", this.queryParam)
				.catch((err) => err);
			if (res) {
				this.actionList = res.actionLogList;
				this.total = res.total;
			}
			this.actionLoading = false;
		},
		sortChange(column) {
			if (column.prop == "createTime") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 1;
				} else {
					this.queryParam.order = 0;
				}
			} else if (column.prop == "type") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 3;
				} else {
					this.queryParam.order = 2;
				}
			} else {
				this.queryParam.order = 0;
			}
			this.getActionList();
		},
		reset() {
			this.queryParam = {
				yearStr: new Date().getFullYear().toString(),
				month: null,
				userName: "",
				type: null,
				field: this.field,
				marked: false,
				order: 0,
				pageSize: 50,
				pageNum: 1,
			};
			this.$refs.ActionTable.columns.forEach((element) => {
				element.order = "";
			});
			this.getActionList();
		},
		pagesizeChange(newSize) {
			this.queryParam.pageSize = newSize;
			this.queryParam.pageNum = 1;
			this.getActionList();
		},
		pagenumChange(newNum) {
			this.queryParam.pageNum = newNum;
			this.getActionList();
		},
		openView(row) {
			this.$refs.ActionDetail.getVal(row);
			this.changeVisible(true);
		},
		async mark(id, yearStr, marked) {
			var text = marked
				? "将要标记此条操作日志，请确定是否继续？"
				: "将要取消此条操作日志的标记，请确定是否继续？";
			const confirmresult = await this.$confirm(text, "提示", {
				conofirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).catch((err) => err);
			if (confirmresult !== "confirm") {
				return this.$message.info("操作已取消！");
			}
			this.actionLoading = true;
			const { data: res } = await this.$http
				.post("al/mark", { yearStr, id, marked })
				.catch((err) => err);
			if (res) {
				this.$message.success("操作成功！");
				this.getActionList();
			}
		},
		async getActionFieldList() {
			const { data: res } = await dataList('log_field').catch((err) => err);
			if (res) {
				this.actionFieldList = res.map((item) => ({
					id: parseInt(item.value),
					label: item.label,
				}));
				console.log(this.actionFieldList);
			}
		},
	},
};
</script>
<style scoped></style>
